import {AsyncResult} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeEvery} from 'redux-saga/effects';
import agentNumberApi from 'Users/api/agentNumberApi';
import {AvailableAgentNumber} from 'Users/components/UserAdministration/UserEntry/AgentNumberInput';
import {AgentNumberActionType, changeAgentNumbers, fetchAgentNumbersByTaxIdentifier} from 'Users/ducks/agentNumber';

function* getAgentNumbersByTaxIdentifierFromApi(action: ReturnType<typeof fetchAgentNumbersByTaxIdentifier>) {
  const data: AsyncResult<AvailableAgentNumber[]> = yield call(
    agentNumberApi.getAgentNumbersByTaxIdentifier,
    action.payload.taxIdentifier,
    action.payload.encryptedIdentifier
  );

  if (E.isRight(data)) {
    yield put(changeAgentNumbers(data.right, action.payload.uniqueKey));
  }
}

function* getAgentNumbersByTaxIdentifierSaga() {
  yield takeEvery(AgentNumberActionType.FETCH_AGENT_NUMBERS_BY_TAX_IDENTIFIER, getAgentNumbersByTaxIdentifierFromApi);
}

export default function*() {
  yield all([getAgentNumbersByTaxIdentifierSaga()]);
}
